import React, { useState, useEffect } from 'react';
import scholarDataJson from '../../data/scholarData.json';

interface ScholarData {
  citations: number;
  hIndex: number;
  i10Index: number;
  sinceYear: string;
  lastUpdated: string;
}

const ScholarStats: React.FC = () => {
  const [scholarData, setScholarData] = useState<ScholarData>({
    citations: 0,
    hIndex: 0,
    i10Index: 0,
    sinceYear: '2021',
    lastUpdated: new Date().toISOString().split('T')[0]
  });

  useEffect(() => {
    // Use the imported JSON data with dynamic "since" year keys
    const data = scholarDataJson as Record<string, unknown>;
    const sinceYear = (data.sinceYear as string) || '2021';
    const dataFromJson: ScholarData = {
      citations: (data['citationsSince' + sinceYear] as number) ?? (data.citations as number) ?? 0,
      hIndex: (data['hIndexSince' + sinceYear] as number) ?? (data.hIndex as number) ?? 0,
      i10Index: (data['i10IndexSince' + sinceYear] as number) ?? (data.i10Index as number) ?? 0,
      sinceYear: sinceYear,
      lastUpdated: (data.lastUpdated as string) || new Date().toISOString().split('T')[0]
    };
    
    setScholarData(dataFromJson);
  }, []);

  return (
    <div style={{ margin: '20px 0' }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div style={{
              background: 'linear-gradient(135deg, #009AEE 0%, #00BFFF 100%)',
              borderRadius: '12px',
              padding: '20px 25px',
              color: 'white',
              textAlign: 'center' as const,
              boxShadow: '0 4px 15px rgba(0, 154, 238, 0.3)'
            }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '30px',
                flexWrap: 'wrap' as const,
                justifyContent: 'center',
                marginBottom: '15px'
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ 
                    fontSize: '1.8rem', 
                    fontWeight: 'bold',
                    lineHeight: 1
                  }}>
                    {scholarData.citations}
                  </div>
                  <div style={{ 
                    fontSize: '0.85rem', 
                    opacity: 0.9,
                    marginTop: '2px'
                  }}>
                    Citations
                  </div>
                </div>
                
                <div style={{ 
                  display: 'flex',
                  flexDirection: 'column' as const,
                  alignItems: 'center',
                  gap: '3px'
                }}>
                  <div style={{
                    width: '3px',
                    height: '3px',
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.8)'
                  }}></div>
                  <div style={{
                    width: '3px',
                    height: '3px',
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.6)'
                  }}></div>
                  <div style={{
                    width: '3px',
                    height: '3px',
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.8)'
                  }}></div>
                </div>
                
                <div style={{ textAlign: 'center' }}>
                  <div style={{ 
                    fontSize: '1.8rem', 
                    fontWeight: 'bold',
                    lineHeight: 1
                  }}>
                    {scholarData.hIndex}
                  </div>
                  <div style={{ 
                    fontSize: '0.85rem', 
                    opacity: 0.9,
                    marginTop: '2px'
                  }}>
                    h-index
                  </div>
                </div>
                
                <div style={{ 
                  display: 'flex',
                  flexDirection: 'column' as const,
                  alignItems: 'center',
                  gap: '3px'
                }}>
                  <div style={{
                    width: '3px',
                    height: '3px',
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.8)'
                  }}></div>
                  <div style={{
                    width: '3px',
                    height: '3px',
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.6)'
                  }}></div>
                  <div style={{
                    width: '3px',
                    height: '3px',
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.8)'
                  }}></div>
                </div>
                
                <div style={{ textAlign: 'center' }}>
                  <div style={{ 
                    fontSize: '1.8rem', 
                    fontWeight: 'bold',
                    lineHeight: 1
                  }}>
                    {scholarData.i10Index}
                  </div>
                  <div style={{ 
                    fontSize: '0.85rem', 
                    opacity: 0.9,
                    marginTop: '2px'
                  }}>
                    i10-index
                  </div>
                </div>
              </div>
              
              <div style={{ 
                fontSize: '0.8rem', 
                opacity: 0.8,
                textAlign: 'center',
                borderTop: '1px solid rgba(255,255,255,0.2)',
                paddingTop: '12px',
                fontWeight: '500'
              }}>
                Since {scholarData.sinceYear}
              </div>
              
              <div style={{ 
                fontSize: '0.7rem', 
                opacity: 0.9,
                textAlign: 'center',
                marginTop: '8px',
                fontStyle: 'italic'
              }}>
                The stats are automatically scraped and synced with Google Scholar every 24 hours
                <br />
                <span style={{ fontSize: '0.65rem', opacity: 0.7 }}>
                  {/* Last updated: {new Date(scholarData.lastUpdated).toLocaleDateString()} */}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScholarStats;
